export interface GeneratePpkCancellationStatementModalData  {
  Title: string;
  WorkerId: number;
  WorkerFormId: number;
  FirstName: string;
  LastName: string;
  DateOfBirth: Date;
  Pesel: string;
}
